export function heroTitleParallax() {
	if (!document.body.classList.contains('home')) {
		return;
	}

	const hero = document.querySelector('.home .strook-hero');
	if (!(hero instanceof HTMLElement)) {
		return;
	}

	const textCarousel = hero.querySelector('.hero-text-carousel');
	if (!(textCarousel instanceof HTMLElement)) {
		return;
	}

	let rafId = 0;

	const update = () => {
		rafId = 0;
		const rect = hero.getBoundingClientRect();
		const heroHeight = Math.max(rect.height, 1);
		const scrolledInsideHero = Math.max(0, -rect.top);
		const maxPinOffset = heroHeight * 0.55;
		const pinOffset = Math.min(scrolledInsideHero * 0.35, maxPinOffset);
		const fadeDistance = Math.max(heroHeight * 0.9, 1);
		const fadeProgress = Math.min(scrolledInsideHero / fadeDistance, 1);
		const opacity = 1 - fadeProgress * 0.8;

		textCarousel.style.transform = `translate3d(0, ${pinOffset.toFixed(2)}px, 0)`;
		textCarousel.style.opacity = opacity.toFixed(3);
	};

	const requestUpdate = () => {
		if (!rafId) {
			rafId = window.requestAnimationFrame(update);
		}
	};

	textCarousel.style.willChange = 'transform';
	window.addEventListener('scroll', requestUpdate, { passive: true });
	window.addEventListener('resize', requestUpdate);
	requestUpdate();
}
